import React from 'react';

import { 
  Box, 
  Typography
} from '@mui/material';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import LowPriorityOutlinedIcon from '@mui/icons-material/LowPriorityOutlined';
import LeakAddOutlinedIcon from '@mui/icons-material/LeakAddOutlined';
import LocalActivityOutlinedIcon from '@mui/icons-material/LocalActivityOutlined';
import CategoryIcon from '@mui/icons-material/Category';
import TableChartIcon from '@mui/icons-material/TableChart';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';
import StorefrontIcon from '@mui/icons-material/Storefront';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import PaymentIcon from '@mui/icons-material/Payment';
import ReceiptOutlinedIcon from '@mui/icons-material/ReceiptOutlined';
import PaidIcon from '@mui/icons-material/Paid';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import FactCheckIcon from '@mui/icons-material/FactCheck';

import "../styles.scss";

const AccountingTPIQBD = ({
  navigate, 
  currentPage
}) => {
  return (
    <Box className="nav__side-common flex_SBColumn" 
      display={"flex"} flexDirection={"column"} gap={"10px"}>
      <Box className="nav__side-container">
        <Box className={`nav__side-item flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi");
          }}>
          <ArrowBackIcon />
          <Typography variant='body2'>
            Back
          </Typography>
        </Box>
        <Box className={`${currentPage === 0 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/connections");
          }}>
          <LeakAddOutlinedIcon />
          <Typography variant='body2'>
            Connections
          </Typography>
        </Box>
        <Box className={`${currentPage === 1 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/operations");
          }}>
          <LowPriorityOutlinedIcon />
          <Typography variant='body2'>
            Operations
          </Typography>
        </Box>
        <Box className={`${currentPage === 2 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/tickets");
          }}>
          <LocalActivityOutlinedIcon />
          <Typography variant='body2'>
            Tickets
          </Typography>
        </Box>
      </Box>
      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Diagnostic tools</i>
      </Typography>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 3 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/payload-injector");
          }}>
            <CategoryIcon />
          <Typography variant='body2'>
            Payload Injection Tester
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Errors</i>
      </Typography>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 4 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/failed-operations");
          }}>
            <CategoryIcon />
          <Typography variant='body2'>
            Failed Operations
          </Typography>
        </Box>
        <Box className={`${currentPage === 5 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/mapping-anomalies");
          }}>
            <CategoryIcon />
          <Typography variant='body2'>
            Mapping Anomalies
          </Typography>
        </Box>
      </Box>

      <Typography
        mt={"12px"}
        mb={"-5px"}>
        <i>Mapping tables</i>
      </Typography>
      <Box className="nav__side-container">
        <Box className={`${currentPage === 6 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/class-mapping");
          }}>
            <CategoryIcon />
          <Typography variant='body2'>
            Classes
          </Typography>
        </Box>
        <Box className={`${currentPage === 7 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/account-mapping");
          }}>
            <TableChartIcon />
          <Typography variant='body2'>
            Chart of accounts
          </Typography>
        </Box>
        <Box className={`${currentPage === 8 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/sales-tax-mapping");
          }}>
            <RequestQuoteIcon />
          <Typography variant='body2'>
            Sales taxes
          </Typography>
        </Box>
        <Box className={`${currentPage === 9 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/item-mapping");
          }}>
            <Inventory2OutlinedIcon />
          <Typography variant='body2'>
            Items
          </Typography>
        </Box>
        <Box className={`${currentPage === 10 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/vendor-mapping");
          }}>
            <StorefrontIcon />
          <Typography variant='body2'>
            Vendors
          </Typography>
        </Box>
        <Box className={`${currentPage === 11 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/customer-mapping");
          }}>
            <PeopleAltOutlinedIcon />
          <Typography variant='body2'>
            Customers
          </Typography>
        </Box>
        <Box className={`${currentPage === 12 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/bill-mapping");
          }}>
            <ReceiptLongIcon />
          <Typography variant='body2'>
            Bills
          </Typography>
        </Box>
        <Box className={`${currentPage === 13 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/bill-payment-mapping");
          }}>
            <PaymentIcon />
          <Typography variant='body2'>
            Bill Payments
          </Typography>
        </Box>
        <Box className={`${currentPage === 14 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/invoice-mapping");
          }}>
            <ReceiptOutlinedIcon />
          <Typography variant='body2'>
            Invoices
          </Typography>
        </Box>
        <Box className={`${currentPage === 15 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/invoice-payment-mapping");
          }}>
            <PaidIcon />
          <Typography variant='body2'>
            Invoice Payments
          </Typography>
        </Box>
        <Box className={`${currentPage === 16 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/journal-entry-mapping");
          }}>
            <MenuBookIcon />
          <Typography variant='body2'>
            Journal Entries
          </Typography>
        </Box>
        <Box className={`${currentPage === 17 ? 'nav__side-selected' : 'nav__side-item'} flexCenter_Row`}
          onClick={() => {
            navigate("/business/accounting-tpi/quickbooks-desktop/check-mapping");
          }}>
            <FactCheckIcon />
          <Typography variant='body2'>
            Checks
          </Typography>
        </Box>
      </Box>
    </Box>
  )
}

export default AccountingTPIQBD;